export const LUXURY = {
  page: "#0B0B0B",
  pageElevated: "#141414",
  pageWash: "none",
  forest: "#1A1A1A",
  forestDeep: "#0B0B0B",
  forestMid: "#242424",
  headerGradient:
    "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 45%, rgba(11,11,11,0.92) 100%)",
  cream: "#F4EFE6",
  creamSoft: "#EDE6D8",
  gold: "#C9A66B",
  goldDeep: "#B8924F",
  goldLine: "rgba(201,166,107,0.32)",
  tan: "#C9A66B",
  orange: "#C9A66B",
  orangeDark: "#B8924F",
  orangeDeep: "#8C6A2E",
  ink: "#F5F2EC",
  muted: "rgba(245,242,236,0.72)",
  hint: "rgba(245,242,236,0.48)",
  stone: "rgba(245,242,236,0.34)",
  card: "#171717",
  cardSoft: "#1E1E1E",
  cardLight: "#F4EFE6",
  cardBorder: "rgba(255,255,255,0.08)",
  /** Text on cream / light cards inside the dark guest portal */
  surfaceInk: "#1C1917",
  surfaceTitle: "#2A241C",
  surfaceMuted: "#57534E",
  surfaceHint: "#78716C",
  surfaceLabel: "#92400E",
  surfaceChipBg: "#EDE6D8",
  surfaceChipText: "#3D3428",
  surfaceBorder: "rgba(61,52,40,0.12)",
  glass: "rgba(22,22,22,0.72)",
  glassBorder: "rgba(255,255,255,0.12)",
  maxWidth: 430,
  displayFont: '"Playfair Display", "Times New Roman", serif',
  bodyFont: '"Inter", "Poppins", sans-serif',
  scriptFont: '"Great Vibes", cursive',
  ctaGradient: "linear-gradient(135deg, #D4B57A 0%, #C9A66B 48%, #B8924F 100%)",
  ctaGradientHover: "linear-gradient(135deg, #C9A66B 0%, #B8924F 100%)",
  ctaShadow: "0 10px 24px rgba(201,166,107,0.28)",
  ctaShadowHover: "0 12px 28px rgba(184,146,79,0.38)",
  cardShadow: "0 12px 28px rgba(0,0,0,0.28)",
  foodShadow: "0 18px 40px rgba(0,0,0,0.45)",
  heroGradient: "linear-gradient(135deg, #1A1A1A 0%, #0B0B0B 100%)",
  barGradient: "linear-gradient(180deg, #141414 0%, #0B0B0B 100%)",
  headerImage: "/assets/guest-hub/header-room.jpg",
  foodImage: "/assets/guest-hub/order-food.jpg",
  palmWatermark: "/assets/guest-hub/palm-watermark.jpg",
  serviceImages: {
    dine: "/assets/guest-hub/order-food.jpg",
    "room-service": "/assets/guest-hub/order-food.jpg",
    housekeeping: "/assets/guest-hub/header-room.jpg",
    laundry: "/assets/guest-hub/palm-watermark.jpg",
    amenities: "/assets/guest-hub/header-room.jpg",
    stay: "/assets/guest-hub/header-room.jpg",
    buffet: "/assets/guest-hub/order-food.jpg",
    offers: "/assets/guest-events/sunset-bbq.jpg",
    events: "/assets/guest-events/moonlight-wellness.jpg",
    concierge: "/assets/guest-hub/header-room.jpg",
    help: "/assets/guest-hub/header-room.jpg",
    maintenance: "/assets/guest-hub/palm-watermark.jpg",
  },
};

/** Matches the hub room / Wi‑Fi glass strip card edge */
export const GLASS_CARD_CHROME = {
  border: `1px solid ${LUXURY.glassBorder}`,
  boxShadow: "0 14px 32px rgba(0,0,0,0.35)",
};

export const IMAGE_CARD_FRAME = GLASS_CARD_CHROME;

export const STAFF_CART = {
  accent: "#6b7dcf",
  gradient: "linear-gradient(135deg, #6b7dcf 0%, #5568d3 100%)",
  gradientHover: "linear-gradient(135deg, #5568d3 0%, #4455c0 100%)",
  shadow: "0 2px 7px rgba(85,104,211,0.32)",
  shadowHover: "0 4px 12px rgba(85,104,211,0.4)",
};

export const getMenuCartChrome = (luxury) =>
  luxury
    ? {
        accent: LUXURY.gold,
        gradient: LUXURY.ctaGradient,
        gradientHover: LUXURY.ctaGradientHover,
        shadow: LUXURY.ctaShadow,
        shadowHover: LUXURY.ctaShadowHover,
      }
    : STAFF_CART;

export const guestDisplayName = (profile) => {
  const name = String(profile?.name || "").trim();
  if (!name || /^guest$/i.test(name)) return "";
  return name;
};
